module.exports = __webpack_public_path__ + "static/media/profile.4026f621.jpg";